import { Errors } from '../errors';
export function validateCall(sec, fun, argc) {
    if (!fun || !fun.axApply) {
        sec.throwError('TypeError', Errors.CallOfNonFunctionError, fun && fun.methodInfo ? fun.methodInfo.getName() : 'value');
    }
    if (fun.methodInfo && argc < fun.methodInfo.minArgs) {
        sec.throwError('ArgumentError', Errors.WrongArgumentCountError, fun.methodInfo.getName(), fun.methodInfo.minArgs, argc);
    }
}
